import React from "react";
import Storage from "../../utils/storage";
import Dummy from "../../assets/assets/account.svg";
import { PropTypes } from "prop-types";

const UserInfo = ({ isGetting, status }) => {
  let userStatus = Storage.get("user-access-data");
  const user = JSON.parse(userStatus);
  let img = user && user.logo;
  let compImg = user && user.company && user.company.logo;
  let username = user && user.first_name;
  let name = user && user.name;

  return (
    <div>
      <div className="dashboard-header">
        <div className="dashboard-header-user-info">
          <div className="user-info-image">
            <img src={img || compImg || Dummy} alt="pic" />
          </div>
          <div className="user-info-names">
            <p>Welcome,</p>
            <h2>{name || username}</h2>
          </div>
        </div>
      </div>
    </div>
  );
};

UserInfo.propTypes = {
  isGetting: PropTypes.bool,
  status: PropTypes.array,
};

export default UserInfo;
